<div class="grid mb-2">
	<!-- SHARED SITE ALERT -->
	<!-- <div *ngIf="currentSite !== undefined && !currentSite.CurrentlyOwned" class="col-12 pt-0">
		<div class="flex align-items-center justify-content-center bg-purple-100 p-1 border-round-xl">
			<i class="pi cm-share text-lg text-purple-700"></i>
			<p-tag [value]="'SHARED_SITE' | translate" styleClass="p-tag-purple"></p-tag>
		</div>
	</div> -->
</div>
<div *ngIf="devices.length > 0 || currentSite?.CurrentlyOwned" class="card px-0 border-round">
	<p-treeTable [value]="devices" [scrollable]="false" [rows]="20" [totalRecords]="devices.length" [paginator]="true"
		currentPageReportTemplate="{{ 'TABLE_REPORT' | translate }}" [showCurrentPageReport]="true" [rowHover]="true"
		(onNodeExpand)="onDeviceExpand($event)" (onNodeCollapse)="onDeviceCollapse($event)">
		<ng-template pTemplate="header" let-columns>
			<!-- <tr>
				<th>{{this.screenWidth >= MIN_WIDTH_COL6 ? this.translate.instant('NAME') : ''}}</th>
				<th *ngIf="this.screenWidth >= MIN_WIDTH_COL6">{{ 'DESCRIPTION' | translate }}</th>
				<th [class]="onExtendedMobile() ? 'w-3rem' : this.screenWidth <= LG_WIDTH ? 'w-9rem' : 'w-12rem'">
					{{ 'SUB_GATEWAY_NEW' | translate }}
				</th>
				<th [class]="onExtendedMobile() ? 'w-3rem' : this.screenWidth <= LG_WIDTH ? 'w-9rem' : 'w-12rem'">
					{{ 'STATUS' | translate }}
				</th>
			</tr> -->
		</ng-template>
		<ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
			<tr [ttRow]="rowNode" (click)="selectDevice(rowData.Id)" class="cursor-pointer"
				[class]="onExtendedMobile() ? 'flex flex-row' : ''"
				[class]="(rowNode.level === 0) ? 'surface-400 hover:bg-blue-200 border-top-1 border-bluegray-900' : ''">
				<!-- <td [class]="onExtendedMobile() ? 'flex w-full' : ''"> -->
				<td>
					<div class="flex align-items-center justify-content-start text-left">
						<p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
						<i class="pi {{rowNode.node.icon}} text-4xl text-primary mr-3"></i>
						<div class="text-xl font-medium" style="white-space: pre-wrap">{{ getSplitString(rowData.Name) |
							truncate:[30]}}</div>
					</div>
				</td>
				<td *ngIf="this.screenWidth >= MIN_WIDTH_COL6">
					<div class="flex align-items-center justify-content-center text-center">
						<div>{{ rowData.Description | truncate:[22] || '' }}</div>
					</div>
				</td>
				<td [class]="onExtendedMobile() ? 'w-3rem' : this.screenWidth <= LG_WIDTH ? 'w-9rem' : 'w-12rem'">
					<div *ngIf="rowNode.node.children.length > 0" class="flex flex-column">
						<p-badge [value]="rowNode.node.children.length" class="ml-3 -mb-1"
							styleClass="text-sm pt-0"></p-badge>
						<i class="pi cm-device-connected-small text-2xl"></i>
					</div>
				</td>
				<td [class]="onExtendedMobile() ? 'w-3rem' : this.screenWidth <= LG_WIDTH ? 'w-9rem' : 'w-12rem'">
					<p-tag *ngIf="!onExtendedMobile()" [value]="getStatus(rowData.Id)"
						[severity]="getStatusColor(rowData.Id)"></p-tag>
					<p-tag *ngIf="onExtendedMobile()" styleClass="p-tag-mobile"
						[severity]="getStatusColor(rowData.Id)"></p-tag>
				</td>
			</tr>
		</ng-template>
		<ng-template pTemplate="emptymessage" let-columns>
			<tr>
				<td colspan="7">{{ 'TABLE_NO_ELEMENT' | translate }}</td>
			</tr>
		</ng-template>
	</p-treeTable>
</div>

<p-confirmDialog #confDialog>
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
				(click)="confDialog.accept()">
			</button>
			<button type="button" pButton [label]="confDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle"
				(click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>